import { render, staticRenderFns } from "./NoticeCdr.vue?vue&type=template&id=6f42e079&scoped=true&"
import script from "./NoticeCdr.vue?vue&type=script&lang=js&"
export * from "./NoticeCdr.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCdr.vue?vue&type=style&index=0&id=6f42e079&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42e079",
  null
  
)

export default component.exports